import { useNavigate } from 'react-router-dom';

function Home() {
  const navigate = useNavigate();

  return (
    <div className="App-body">
      <div style={{ display: 'inline-flex', flexDirection: 'column', gap: 16, alignItems: 'stretch' }}>
        <h1 style={{ fontWeight: 'normal', margin: 0, marginBottom: 16 }}>Bloom</h1>
        <button className="dpp-button" style={{ width: '100%' }} onClick={() => navigate('/brand')}>Brand</button>
        <button className="dpp-button" style={{ width: '100%' }} onClick={() => navigate('/user')}>User</button>
      </div>
    </div>
  );
}

export default Home;
